export default function ScenarioBranches({ frames, scenarios, activeView, setActiveView, setCurrentIdx }) {
  if (!scenarios.length) return null;
  const pctOf = (frame) => {
    const idx = frames.indexOf(frame);
    return frames.length > 1 ? (idx / (frames.length - 1)) * 100 : 0;
  };

  return (
    <div style={{padding:"2px 16px 12px"}}>
      {scenarios.map(sc=>{
        const startPct = pctOf(sc.frame);
        return (
          <div key={sc.id} style={{display:"flex",alignItems:"center",gap:8,marginBottom:4}}>
            <div style={{width:64,fontSize:9,fontWeight:700,color:sc.color,textAlign:"right",flexShrink:0}}>
              {sc.label.toUpperCase()}
            </div>
            <div style={{flex:1,position:"relative",height:14}}
              onClick={()=>{ setActiveView(sc.id); setCurrentIdx(frames.indexOf(sc.frame)); }}
            >
              {/* branch line from branch point to end */}
              <div style={{
                position:"absolute", left:`${startPct}%`, right:0, top:6, height:2,
                background: sc.color, opacity: activeView===sc.id ? 0.9 : 0.4,
                borderTop: `2px dashed ${sc.color}`, cursor:"pointer",
              }}/>
              {/* branch point */}
              <div title={`Branched at frame ${sc.frame}`} style={{
                position:"absolute", left:`${startPct}%`, top:2, width:9, height:9,
                borderRadius:"50%", background:sc.color, transform:"translateX(-50%)",
                cursor:"pointer", boxShadow: activeView===sc.id ? `0 0 6px ${sc.color}` : "none",
              }}/>
            </div>
          </div>
        );
      })}
    </div>
  );
}
